import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ReportCard } from "@/components/ReportCard";

export default function Research() {
  const [reports, setReports] = useState([]);
  const [papers, setPapers] = useState([]);
  useEffect(() => {
    api.get("/reports").then((r) => setReports(r.data));
    api.get("/articles", { params: { type: "research" } }).then((r) => setPapers(r.data));
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 lg:py-20" data-testid="research-page">
      <div className="grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7">
          <p className="overline text-[#E5332A]">Research store</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 leading-[1.05]">Sector reports for decision-makers.</h1>
        </div>
        <p className="lg:col-span-4 lg:col-start-9 text-[#575757] self-end leading-relaxed">Buy individual reports with lifetime access. A new Monthly Africa Brew Brief Report lands on the 27th of every month, included with Pro; Institutional includes every report.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-8 mt-14">
        {reports.map((r, i) => <ReportCard key={r.slug} r={r} index={i} />)}
      </div>
      {papers.length > 0 && (
        <div className="mt-20">
          <h2 className="font-display text-2xl sm:text-3xl font-bold border-b border-[#E7E7E7] pb-4">Research papers</h2>
          {papers.map((p) => (
            <a key={p.slug} href={`/article/${p.slug}`} className="block py-6 border-b border-[#E7E7E7] group" data-testid={`research-paper-${p.slug}`}>
              <p className="overline text-[#0A0A0A]">{p.category} · Institutional</p>
              <p className="font-display text-xl font-semibold mt-2 group-hover:text-[#E5332A]">{p.title}</p>
              <p className="text-sm text-[#575757] mt-1">{p.excerpt}</p>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
